export const DATE_FORMAT_DATE_PICKER = 'dd.MM.yyyy';
export const DATE_FORMAT_CSV = 'dd/MM/yyyy';
export const DATE_FORMAT_READABLE_CUR_YEAR = 'dd MMM';
export const DATE_FORMAT_READABLE_SHORT_YEAR = 'dd MMM yy';
export const DATE_FORMAT_READABLE = 'dd MMM yyyy';
export const DATE_FORMAT_SHORT_API = 'yyyy-MM-dd';
export const TIME_FORMAT_MINUTES = 'HH:mm';
export const TIME_FORMAT_SECONDS = `${TIME_FORMAT_MINUTES}:ss`;
export const DATETIME_FORMAT_READABLE_MINUTES = `${DATE_FORMAT_READABLE} ${TIME_FORMAT_MINUTES}`;
export const DATETIME_FORMAT_READABLE = `${DATE_FORMAT_READABLE} ${TIME_FORMAT_SECONDS}`;

export const DATE_RANGE_DEFAULT_VALUE: [null, null] = [null, null];

export const ITEMS_PER_PAGE_DEFAULT = 10;

export const PAGE_DEFAULT = 1;

export const SORT_ASC = 'asc';

export const SORT_DESC = 'desc';

export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc',
}

export const enum MODAL_TYPES {
  CONFIRMATION_MODAL = 'confirmation',
  NEWS_ALERT_MODAL = 'newsAlertModal',
  SMART_POPUNDER_MODAL = 'smartPopunder',
  SMART_POPUNDER_VARIATION_MODAL = 'smartPopunderVariation',
  SMART_POPUNDER_WEIGHTS_MODAL = 'smartPopunderWeights',
  TEST_POSTBACK_URL_RESULT_MODAL = 'testPostbackUrlResultModal',
  EDIT_EASY_LINK_MODAL = 'editEasyLinkModal',
  ADD_EASY_LINK_MODAL = 'addEasyLinkModal',
  BULK_PAYOUTS_MODAL = 'bulkPayoutsModal',
  CRM_HOT_LEAD = 'crmHotLead',
  SURVEY_QUESTIONS = 'questionnaire',
  ADD_DOMAIN_MANAGEMENT_MODAL = 'addDomainManagementModal',
  EDIT_DOMAIN_MANAGEMENT_MODAL = 'editDomainManagementModal',
}

export const DEFAULT_SYSTEM_NOTIFICATION_TIMEOUT = 3000;

export const OTHER_COUNTRIES_LABEL = 'Other countries';

export const DEVICES_NAMES_MAP = {
  desktop: 'Desktop',
  mobile: 'Mobile',
  tablet: 'Tablet',
  other: 'Other',
};

export const TABLE_OFFSET_TOP = 50;

export const DEFAULT_SOURCE_ID = 0;

export const MINUTE = 60 * 1000;

export const LS_THEME_ID = 'themeId';
export const CHECK_THEME_SYSEND_EVENT = 'checkThemeId';
